import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Post-login landing page: management dashboard for users who can see it,
// operations (accessible to every authenticated user) for everyone else.
const DefaultRedirect = () => {
  const { hasAccess } = useAuth();
  return <Navigate to={hasAccess('management') ? '/management' : '/operations'} replace />;
};

export default DefaultRedirect;
